import React from 'react';
import * as Styled from './loaderStyled';

const Modal = props => (
  <Styled.ModalMainDiv>
    <Styled.ModalDiv
      style={{
        transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.show ? 1 : 0,
      }}
    >
      <Styled.LoaderWrapDiv>
        <Styled.OutlineImg src="/outline.svg" />
        <Styled.AnimationDiv>
          <Styled.WaveImg src="/wave_1.svg" zindex="3" duration="1s" />
          <Styled.WaveImg src="/wave_2.svg" zindex="1" duration="2s" />
          <Styled.BubbleDiv style={{ left: '10%', backgroundColor: '#fc8ac1' }} duration="1s" />
          <Styled.BubbleDiv style={{ left: '30%', backgroundColor: '#f0b7d2' }} duration="2s" />
          <Styled.BubbleDiv style={{ left: '60%', backgroundColor: '#e9589e' }} duration="3s" />
        </Styled.AnimationDiv>
      </Styled.LoaderWrapDiv>
      <Styled.HeadingDiv>Please Wait ...</Styled.HeadingDiv>
      <Styled.SubHeadingDiv>{props.heading}</Styled.SubHeadingDiv>
    </Styled.ModalDiv>
    <Styled.ModalWrapDiv style={{ display: props.show ? 'block' : 'none' }} />
  </Styled.ModalMainDiv>
)

export default Modal
